import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesizePipe } from './file-size.pipe';
import { SortPipe } from './sort.pipe';
import { Prop2arrPipe } from './prop2arr.pipe';
import { Obj2arrPipe } from './obj2arr.pipe';



@NgModule({
  declarations: [
    FilesizePipe,
    Obj2arrPipe,
    Prop2arrPipe,
    SortPipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    FilesizePipe,
    Obj2arrPipe,
    Prop2arrPipe,
    SortPipe    
  ]
})
export class PipesModule { }
